import { getToken } from "../token";

// Fetch product by ID
export async function getProductById(token, id) {
  const result = await fetch(`https://api.iheartjane.com/roots/store_operations_api/v1/menu_products/menu_product_slug?slug_or_product_id=${id}&store_ids=117&store_ids=5981`, {
    headers: {
      credentials: 'include',
      accept: 'application/json',
      Authorization: `Bearer ${token}`,
    }
  });
  if (!result.ok) {
    throw new Error('Failed to fetch product');
  }
  const data = await result.json();
  return data;
}

export default async function handler(req, res) {
  const token = await getToken(); 
  const { id } = req.query;

  if (!id) {
    res.status(400).json({ error: 'Product ID is required' });
    return;
  }

  try {
    const product = await getProductById(token.access_token, id);
    res.status(200).json(product);
  } catch (error) {
    res.status(500).json({ error: 'Failed to fetch product' });
  }
}
